import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div className="centered-spinner">
      <TailSpin
        type="TailSpin"
        color="rgb(155, 236, 34)"
        height={70}
        width={70}
        timeout={5000}
      />
    </div>
  );
};

export default Loader;
